package gr.tech.GRAttestation.models.user.auth

import kotlinx.serialization.Serializable

@Serializable
data class UserLoginModel(
    val email: String,
    val password: String,
)